// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9e994783","732":"c173fff8"}[chunkId] + ".chunk.js";
};